import { CountryCode } from '~/enums';
import { Language } from '~/store/types/sharedTypes';

// Split language to ignore market in case langauge contains both variables. (For example NL_BE).
// Format of locale: language_MARKET
export const generateLocale = (language: Language, market: CountryCode) =>
  `${language.split('_')[0].toLowerCase()}-${market.toUpperCase()}`;
